import { DROP_Z_INDEX } from 'constants/layout';
import { SolitaireGame } from '../SolitaireGame';
import { Card } from 'components/Card';

export function refreshPyramidCards(solitaireGame: SolitaireGame) {
    const pyramidRows = solitaireGame.columns.length;
    
    for (let row = solitaireGame.columns.length - 1; row >= 0; row--) {
        const column = solitaireGame.columns[row];
        
        for (let col = 0; col < column.cards.length; col++) {
            const card = column.cards[col];
            if (!card) continue;

            let isUncovered = false;
            if (row === pyramidRows - 1) {
                isUncovered = true;
            } else {
                const nextRow = solitaireGame.columns[row + 1];
                const coverLeft = nextRow.cards[col] || null;
                const coverRight = nextRow.cards[col + 1] || null;
                if (!coverLeft && !coverRight) {
                    isUncovered = true;
                }
            }
            card.setActive(isUncovered);
        }
    }
}

export function refreshZIndexes(solitaireGame: SolitaireGame) {
    for (let row = solitaireGame.columns.length - 1; row >= 0; row--) {
        const column = solitaireGame.columns[row];
        
        for (let col = 0; col < column.cards.length; col++) {
            const card = column.cards[col];
            if (!card) continue;

            card.container.zIndex = DROP_Z_INDEX + row * 10 + col;
        }
    }
}

// Получает карту из пирамиды по координатам
export function getPyramidCard(solitaireGame: SolitaireGame, row: number, col: number): Card | null {
    if (row < 0 || row >= solitaireGame.columns.length) {
        console.warn(`[PYRAMID] Invalid row index: ${row}`);
        return null;
    }
    
    const column = solitaireGame.columns[row];
    if (col < 0 || col >= column.cards.length) {
        console.warn(`[PYRAMID] Invalid col index: ${col} for row: ${row}`);
        return null;
    }
    
    const card = column.cards[col];
    console.log(`[PYRAMID] Getting card at row:${row} col:${col} - Found:`, card ? `${card.code} (${card.value})` : 'null');
    return card;
}

// Проверяет, доступна ли карта для игры (не покрыта другими картами)
export function isCardPlayable(solitaireGame: SolitaireGame, row: number, col: number): boolean {
    const card = getPyramidCard(solitaireGame, row, col);
    if (!card) {
        console.warn(`[PLAYABILITY] No card found at row:${row} col:${col} for playability check`);
        return false;
    }
    
    const isPlayable = card.active && card.visible;
    return isPlayable;
}

export function getPlayablePyramidCards(solitaireGame: SolitaireGame): Card[] {
    console.log('[PLAYABLE CARDS] Starting search for playable pyramid cards');
    const playableCards: Card[] = [];
    
    for (let row = solitaireGame.columns.length - 1; row >= 0; row--) {
        for (let col = 0; col < solitaireGame.columns[row].cards.length; col++) {
            console.log(`[PLAYABLE CARDS] Checking card at row:${row} col:${col}`);
            
            if (isCardPlayable(solitaireGame, row, col)) {
                const card = getPyramidCard(solitaireGame, row, col);
                if (card) {
                    playableCards.push(card);
                    console.log(`[PLAYABLE CARDS] Added playable card: ${card.code}(${card.value}) at row:${row} col:${col}`);
                }
            } else {
                const card = getPyramidCard(solitaireGame, row, col);
                if (card) {
                    console.log(`[PLAYABLE CARDS] Card ${card.code}(${card.value}) at row:${row} col:${col} is NOT playable`);
                }
            }
        }
    }
    
    console.log(`[PLAYABLE CARDS] Found ${playableCards.length} playable cards:`, playableCards.map(c => `${c.code}(${c.value})`));
    return playableCards;
}

export function getNonPlayablePyramidCards(solitaireGame: SolitaireGame): Card[] {
    const playableCards: Card[] = [];
    
    for (let row = solitaireGame.columns.length - 1; row >= 0; row--) {
        for (let col = 0; col < solitaireGame.columns[row].cards.length; col++) {
            
            if (!isCardPlayable(solitaireGame, row, col)) {
                const card = getPyramidCard(solitaireGame, row, col);
                if (card) {
                    playableCards.push(card);
                }
            }
        }
    }
    
    return playableCards;
}

// Проверяет, можно ли убрать пару карт (сумма = 13)
export function canRemovePyramidCardPair(card1: Card, card2: Card): boolean {
    const sum = card1.value + card2.value;
    const canRemove = sum === 13;
    console.log(`[PYRAMID] Checking card pair: ${card1.code}(${card1.value}) + ${card2.code}(${card2.value}) = ${sum}, Can remove: ${canRemove}`);
    return canRemove;
}

// Проверяет, можно ли убрать короля (K = 13)
export function canRemoveKing(card: Card): boolean {
    const canRemove = card.value === 13;
    console.log(`[PYRAMID] Checking king removal: ${card.code}(${card.value}), Can remove: ${canRemove}`);
    return canRemove;
}